// CV Label Translations
// Extracted from App.tsx to reduce file size (~991 lines)

export type Language = 'deutsch' | 'englisch' | 'französisch' | 'italienisch';

export const cvLabelTranslations: { [key: string]: { [key in Language]: string } } = {
  'Name:': {
    'deutsch': 'Name:',
    'englisch': 'Name:',
    'französisch': 'Nom:',
    'italienisch': 'Nome:'
  },
  'Adresse:': {
    'deutsch': 'Adresse:',
    'englisch': 'Address:',
    'französisch': 'Adresse:',
    'italienisch': 'Indirizzo:'
  },
  'PLZ:': {
    'deutsch': 'PLZ:',
    'englisch': 'Postal Code:',
    'französisch': 'Code postal:',
    'italienisch': 'CAP:'
  },
  'Stadt:': {
    'deutsch': 'Stadt:',
    'englisch': 'City:',
    'französisch': 'Ville:',
    'italienisch': 'Città:'
  },
  'Land:': {
    'deutsch': 'Land:',
    'englisch': 'Country:',
    'französisch': 'Pays:',
    'italienisch': 'Paese:'
  },
  'Verfügbar ab:': {
    'deutsch': 'Verfügbar ab:',
    'englisch': 'Available from:',
    'französisch': 'Disponible à partir de:',
    'italienisch': 'Disponibile da:'
  },
  'Telefon:': {
    'deutsch': 'Telefon:',
    'englisch': 'Phone:',
    'französisch': 'Téléphone:',
    'italienisch': 'Telefono:'
  },
  'Email:': {
    'deutsch': 'Email:',
    'englisch': 'Email:',
    'französisch': 'Email:',
    'italienisch': 'Email:'
  },
  'Geburtsjahr:': {
    'deutsch': 'Geburtsjahr:',
    'englisch': 'Birth Year:',
    'französisch': 'Année de naissance:',
    'italienisch': 'Anno di nascita:'
  },
  'Nationalität:': {
    'deutsch': 'Nationalität:',
    'englisch': 'Nationality:',
    'französisch': 'Nationalité:',
    'italienisch': 'Nazionalità:'
  },
  'Aufenthaltsbewilligung:': {
    'deutsch': 'Aufenthaltsbewilligung:',
    'englisch': 'Residence Permit:',
    'französisch': 'Permis de séjour:',
    'italienisch': 'Permesso di soggiorno:'
  },
  'Familienstand:': {
    'deutsch': 'Familienstand:',
    'englisch': 'Marital Status:',
    'französisch': 'État civil:',
    'italienisch': 'Stato civile:'
  },
  'Profil:': {
    'deutsch': 'Profil:',
    'englisch': 'Profile:',
    'französisch': 'Profil:',
    'italienisch': 'Profilo:'
  },
  'Profilbild:': {
    'deutsch': 'Profilbild:',
    'englisch': 'Profile Picture:',
    'französisch': 'Photo de profil:',
    'italienisch': 'Foto del profilo:'
  },
  'Signatur:': {
    'deutsch': 'Signatur:',
    'englisch': 'Signature:',
    'französisch': 'Signature:',
    'italienisch': 'Firma:'
  },
  'CV-Daten sind wahrheitsgetreu und aktuell.': {
    'deutsch': 'CV-Daten sind wahrheitsgetreu und aktuell.',
    'englisch': 'CV data is truthful and up-to-date.',
    'französisch': 'Les données du CV sont exactes et à jour.',
    'italienisch': 'I dati del CV sono veritieri e aggiornati.'
  },
  'CV-Daten': {
    'deutsch': 'CV-Daten',
    'englisch': 'CV Data',
    'französisch': 'Données CV',
    'italienisch': 'Dati CV'
  },
  'Bitte überprüfe deine CV-Daten genau und nimm nötige Änderungen direkt in dieser Maske vor.': {
    'deutsch': 'Bitte überprüfe deine CV-Daten genau und nimm nötige Änderungen direkt in dieser Maske vor.',
    'englisch': 'Please check your CV data carefully and make necessary changes directly in this form.',
    'französisch': 'Veuillez vérifier attentivement vos données CV et apporter les modifications nécessaires directement dans ce formulaire.',
    'italienisch': 'Si prega di controllare attentamente i dati del CV e apportare le modifiche necessarie direttamente in questo modulo.'
  },
  'Daten speichern': {
    'deutsch': 'Daten speichern',
    'englisch': 'Save data',
    'französisch': 'Enregistrer les données',
    'italienisch': 'Salva dati'
  },
  'Keine Änderungen zum Speichern': {
    'deutsch': 'Keine Änderungen zum Speichern',
    'englisch': 'No changes to save',
    'französisch': 'Aucune modification à enregistrer',
    'italienisch': 'Nessuna modifica da salvare'
  },
  'CV-Daten bearbeiten': {
    'deutsch': 'CV-Daten bearbeiten',
    'englisch': 'Edit CV Data',
    'französisch': 'Modifier les données CV',
    'italienisch': 'Modifica dati CV'
  },
  'CV-Daten exportieren': {
    'deutsch': 'CV-Daten exportieren',
    'englisch': 'Export CV Data',
    'französisch': 'Exporter les données CV',
    'italienisch': 'Esporta dati CV'
  },
  'Stellenbeschreibung erfassen': {
    'deutsch': 'Stellenbeschreibung erfassen',
    'englisch': 'Enter Job Description',
    'französisch': 'Saisir la description du poste',
    'italienisch': 'Inserisci descrizione del lavoro'
  },
  'Neue Stellenbeschreibung erfassen': {
    'deutsch': 'Neue Stellenbeschreibung erfassen',
    'englisch': 'Enter New Job Description',
    'französisch': 'Saisir une nouvelle description du poste',
    'italienisch': 'Inserisci nuova descrizione del lavoro'
  },
  'Logout': {
    'deutsch': 'Abmelden',
    'englisch': 'Logout',
    'französisch': 'Déconnexion',
    'italienisch': 'Disconnetti'
  },
  'Beenden': {
    'deutsch': 'Beenden',
    'englisch': 'Finish',
    'französisch': 'Terminer',
    'italienisch': 'Terminare'
  },
  'Ungespeicherte Änderungen': {
    'deutsch': 'Ungespeicherte Änderungen',
    'englisch': 'Unsaved Changes',
    'französisch': 'Modifications non enregistrées',
    'italienisch': 'Modifiche non salvate'
  },
  'Sie haben ungespeicherte Änderungen. Möchten Sie wirklich schließen ohne zu speichern?': {
    'deutsch': 'Sie haben ungespeicherte Änderungen. Möchten Sie wirklich schließen ohne zu speichern?',
    'englisch': 'You have unsaved changes. Do you really want to close without saving?',
    'französisch': 'Vous avez des modifications non enregistrées. Voulez-vous vraiment fermer sans enregistrer?',
    'italienisch': 'Hai modifiche non salvate. Vuoi davvero chiudere senza salvare?'
  },
  'Abbrechen': {
    'deutsch': 'Abbrechen',
    'englisch': 'Cancel',
    'französisch': 'Annuler',
    'italienisch': 'Annulla'
  },
  'Ohne Speichern schließen': {
    'deutsch': 'Ohne Speichern schließen',
    'englisch': 'Close without saving',
    'französisch': 'Fermer sans enregistrer',
    'italienisch': 'Chiudi senza salvare'
  },
  'Stellenbeschreibung eingeben (Copy/Paste oder URL per Drag & Drop)': {
    'deutsch': 'Stellenbeschreibung eingeben (Copy/Paste oder URL per Drag & Drop)',
    'englisch': 'Enter Job Description (Copy/Paste or URL by Drag & Drop)',
    'französisch': 'Saisir la description du poste (Copier/Coller ou URL par glisser-déposer)',
    'italienisch': 'Inserisci descrizione del lavoro (Copia/Incolla o URL tramite trascinamento)'
  },
  'Extrahiere Text von Webseite...': {
    'deutsch': 'Extrahiere Text von Webseite...',
    'englisch': 'Extracting text from website...',
    'französisch': 'Extraction du texte du site web...',
    'italienisch': 'Estrazione del testo dal sito web...'
  },
  'Fügen Sie hier die vollständige Stellenbeschreibung ein oder ziehen Sie einen Link hinein...': {
    'deutsch': 'Fügen Sie hier die vollständige Stellenbeschreibung ein oder ziehen Sie einen Link hinein...',
    'englisch': 'Paste the complete job description here or drag a link into it...',
    'französisch': 'Collez ici la description complète du poste ou faites glisser un lien...',
    'italienisch': 'Incolla qui la descrizione completa del lavoro o trascina un link...'
  },
  'Sprache Stellenbeschreibung': {
    'deutsch': 'Sprache Stellenbeschreibung',
    'englisch': 'Job Description Language',
    'französisch': 'Langue de la description du poste',
    'italienisch': 'Lingua della descrizione del lavoro'
  },
  'Passgenauigkeit prüfen': {
    'deutsch': 'Passgenauigkeit prüfen',
    'englisch': 'Check Match Score',
    'französisch': 'Vérifier la correspondance',
    'italienisch': 'Verifica corrispondenza'
  },
  'Passgenauigkeit:': {
    'deutsch': 'Passgenauigkeit:',
    'englisch': 'Match Score:',
    'französisch': 'Correspondance:',
    'italienisch': 'Corrispondenza:'
  },
  'Fehlende Skills/Erfahrungen:': {
    'deutsch': 'Fehlende Skills/Erfahrungen:',
    'englisch': 'Missing Skills/Experiences:',
    'französisch': 'Compétences/Expériences manquantes:',
    'italienisch': 'Competenze/Esperienze mancanti:'
  },
  'Ergänzt': {
    'deutsch': 'Ergänzt',
    'englisch': 'Added',
    'französisch': 'Ajouté',
    'italienisch': 'Aggiunto'
  },
  'CV optimieren': {
    'deutsch': 'CV optimieren',
    'englisch': 'Optimize CV',
    'französisch': 'Optimiser le CV',
    'italienisch': 'Ottimizza CV'
  },
  'CV anzeigen': {
    'deutsch': 'CV anzeigen',
    'englisch': 'Show CV',
    'französisch': 'Afficher le CV',
    'italienisch': 'Mostra CV'
  },
  'oder': {
    'deutsch': 'oder',
    'englisch': 'or',
    'französisch': 'ou',
    'italienisch': 'o'
  },
  'CV-Vorschau': {
    'deutsch': 'CV-Vorschau',
    'englisch': 'CV Preview',
    'französisch': 'Aperçu du CV',
    'italienisch': 'Anteprima CV'
  },
  'Motivationsschreiben-Vorschau': {
    'deutsch': 'Motivationsschreiben-Vorschau',
    'englisch': 'Cover Letter Preview',
    'französisch': 'Aperçu de la lettre de motivation',
    'italienisch': 'Anteprima lettera di motivazione'
  },
  'Vorschau': {
    'deutsch': 'Vorschau',
    'englisch': 'Preview',
    'französisch': 'Aperçu',
    'italienisch': 'Anteprima'
  },
  'Profilbild anzeigen': {
    'deutsch': 'Profilbild anzeigen',
    'englisch': 'Show Profile Picture',
    'französisch': 'Afficher la photo de profil',
    'italienisch': 'Mostra foto profilo'
  },
  'Kurzprofil anzeigen': {
    'deutsch': 'Kurzprofil anzeigen',
    'englisch': 'Show Short Profile',
    'französisch': 'Afficher le profil court',
    'italienisch': 'Mostra profilo breve'
  },
  'Kernkompetenzen anzeigen': {
    'deutsch': 'Kernkompetenzen anzeigen',
    'englisch': 'Show Core Competencies',
    'französisch': 'Afficher les compétences clés',
    'italienisch': 'Mostra competenze chiave'
  },
  'Zertifizierungen anzeigen': {
    'deutsch': 'Zertifizierungen anzeigen',
    'englisch': 'Show Certifications',
    'französisch': 'Afficher les certifications',
    'italienisch': 'Mostra certificazioni'
  },
  'IT-Skills anzeigen': {
    'deutsch': 'IT-Skills anzeigen',
    'englisch': 'Show IT Skills',
    'französisch': 'Afficher les compétences IT',
    'italienisch': 'Mostra competenze IT'
  },
  'Branchen anzeigen': {
    'deutsch': 'Branchen anzeigen',
    'englisch': 'Show Industries',
    'französisch': 'Afficher les secteurs',
    'italienisch': 'Mostra settori'
  },
  'Sprachen anzeigen': {
    'deutsch': 'Sprachen anzeigen',
    'englisch': 'Show Languages',
    'französisch': 'Afficher les langues',
    'italienisch': 'Mostra lingue'
  },
  'Hobbys anzeigen': {
    'deutsch': 'Hobbys anzeigen',
    'englisch': 'Show Hobbies',
    'französisch': 'Afficher les loisirs',
    'italienisch': 'Mostra hobby'
  },
  'Ausbildung anzeigen': {
    'deutsch': 'Ausbildung anzeigen',
    'englisch': 'Show Education',
    'französisch': 'Afficher la formation',
    'italienisch': 'Mostra formazione'
  },
  'Berufserfahrung anzeigen': {
    'deutsch': 'Berufserfahrung anzeigen',
    'englisch': 'Show Work Experience',
    'französisch': 'Afficher l\'expérience professionnelle',
    'italienisch': 'Mostra esperienza lavorativa'
  },
  'Weitere Berufserfahrungen anzeigen': {
    'deutsch': 'Weitere Berufserfahrungen anzeigen',
    'englisch': 'Show Additional Work Experience',
    'französisch': 'Afficher l\'expérience professionnelle supplémentaire',
    'italienisch': 'Mostra esperienza lavorativa aggiuntiva'
  },
  'Zusätzliche Infos anzeigen': {
    'deutsch': 'Zusätzliche Infos anzeigen',
    'englisch': 'Show Additional Information',
    'französisch': 'Afficher les informations supplémentaires',
    'italienisch': 'Mostra informazioni aggiuntive'
  },
  'Header': {
    'deutsch': 'Header',
    'englisch': 'Header',
    'französisch': 'En-tête',
    'italienisch': 'Intestazione'
  },
  'Spalte:': {
    'deutsch': 'Spalte:',
    'englisch': 'Column:',
    'französisch': 'Colonne:',
    'italienisch': 'Colonna:'
  },
  'Textfarben': {
    'deutsch': 'Textfarben',
    'englisch': 'Text Colors',
    'französisch': 'Couleurs du texte',
    'italienisch': 'Colori del testo'
  },
  'Reset Design': {
    'deutsch': 'Reset Design',
    'englisch': 'Reset Design',
    'französisch': 'Réinitialiser le design',
    'italienisch': 'Ripristina design'
  },
  'Modern': {
    'deutsch': 'Modern',
    'englisch': 'Modern',
    'französisch': 'Moderne',
    'italienisch': 'Moderno'
  },
  'Professional': {
    'deutsch': 'Professional',
    'englisch': 'Professional',
    'französisch': 'Professionnel',
    'italienisch': 'Professionale'
  },
  'Classic': {
    'deutsch': 'Classic',
    'englisch': 'Classic',
    'französisch': 'Classique',
    'italienisch': 'Classico'
  },
  'Profilbild im CV-Template anzeigen': {
    'deutsch': 'Profilbild im CV-Template anzeigen',
    'englisch': 'Show Profile Picture in CV Template',
    'französisch': 'Afficher la photo de profil dans le modèle CV',
    'italienisch': 'Mostra foto profilo nel template CV'
  },
  'Klicken und ziehen, um die Position zu ändern': {
    'deutsch': 'Klicken und ziehen, um die Position zu ändern',
    'englisch': 'Click and drag to change position',
    'französisch': 'Cliquer et faire glisser pour modifier la position',
    'italienisch': 'Fare clic e trascinare per modificare la posizione'
  },
  'Rundung:': {
    'deutsch': 'Rundung:',
    'englisch': 'Roundness:',
    'französisch': 'Arrondi:',
    'italienisch': 'Arrotondamento:'
  },
  'Eckig': {
    'deutsch': 'Eckig',
    'englisch': 'Square',
    'französisch': 'Carré',
    'italienisch': 'Quadrato'
  },
  'Rund': {
    'deutsch': 'Rund',
    'englisch': 'Round',
    'französisch': 'Rond',
    'italienisch': 'Rotondo'
  },
  'Rahmen': {
    'deutsch': 'Rahmen',
    'englisch': 'Border',
    'französisch': 'Bordure',
    'italienisch': 'Bordo'
  },
  'Rahmen um das Profilbild anzeigen': {
    'deutsch': 'Rahmen um das Profilbild anzeigen',
    'englisch': 'Show border around profile picture',
    'französisch': 'Afficher la bordure autour de la photo de profil',
    'italienisch': 'Mostra bordo attorno alla foto profilo'
  },
  'Rahmenfarbe': {
    'deutsch': 'Rahmenfarbe',
    'englisch': 'Border Color',
    'französisch': 'Couleur de bordure',
    'italienisch': 'Colore bordo'
  },
  'Rahmendicke:': {
    'deutsch': 'Rahmendicke:',
    'englisch': 'Border Thickness:',
    'französisch': 'Épaisseur de bordure:',
    'italienisch': 'Spessore bordo:'
  },
  'Breite:': {
    'deutsch': 'Breite:',
    'englisch': 'Width:',
    'französisch': 'Largeur:',
    'italienisch': 'Larghezza:'
  },
  'Profilbild-Größe': {
    'deutsch': 'Profilbild-Größe',
    'englisch': 'Profile Picture Size',
    'französisch': 'Taille de la photo de profil',
    'italienisch': 'Dimensione foto profilo'
  },
  'Profilbild-Ausrichtung': {
    'deutsch': 'Profilbild-Ausrichtung',
    'englisch': 'Profile Picture Alignment',
    'französisch': 'Alignement de la photo de profil',
    'italienisch': 'Allineamento foto profilo'
  },
  'Links': {
    'deutsch': 'Links',
    'englisch': 'Left',
    'französisch': 'Gauche',
    'italienisch': 'Sinistra'
  },
  'Mittig': {
    'deutsch': 'Mittig',
    'englisch': 'Center',
    'französisch': 'Centre',
    'italienisch': 'Centro'
  },
  'Rechts': {
    'deutsch': 'Rechts',
    'englisch': 'Right',
    'französisch': 'Droite',
    'italienisch': 'Destra'
  },
  'Schließen': {
    'deutsch': 'Schließen',
    'englisch': 'Close',
    'französisch': 'Fermer',
    'italienisch': 'Chiudi'
  },
  'Profil im CV-Template anzeigen': {
    'deutsch': 'Profil im CV-Template anzeigen',
    'englisch': 'Show Profile in CV Template',
    'französisch': 'Afficher le profil dans le modèle CV',
    'italienisch': 'Mostra profilo nel template CV'
  },
  'Bearbeiten Sie Ihr Profil:': {
    'deutsch': 'Bearbeiten Sie Ihr Profil:',
    'englisch': 'Edit your profile:',
    'französisch': 'Modifiez votre profil:',
    'italienisch': 'Modifica il tuo profilo:'
  },
  'Profil-Text': {
    'deutsch': 'Profil-Text',
    'englisch': 'Profile Text',
    'französisch': 'Texte du profil',
    'italienisch': 'Testo profilo'
  },
  'Beschreiben Sie sich selbst, Ihre Ziele und Ihre Stärken...': {
    'deutsch': 'Beschreiben Sie sich selbst, Ihre Ziele und Ihre Stärken...',
    'englisch': 'Describe yourself, your goals and your strengths...',
    'französisch': 'Décrivez-vous, vos objectifs et vos points forts...',
    'italienisch': 'Descrivi te stesso, i tuoi obiettivi e i tuoi punti di forza...'
  },
  'Prompts zur Verbesserung des Kurzprofils': {
    'deutsch': 'Prompts zur Verbesserung des Kurzprofils',
    'englisch': 'Prompts to improve the short profile',
    'französisch': 'Prompts pour améliorer le profil court',
    'italienisch': 'Prompt per migliorare il profilo breve'
  },
  'Prompts zur Verbesserung der Beschreibung': {
    'deutsch': 'Prompts zur Verbesserung der Beschreibung',
    'englisch': 'Prompts to improve the description',
    'französisch': 'Prompts pour améliorer la description',
    'italienisch': 'Prompt per migliorare la descrizione'
  },
  'Kurzprofil mit Prompt verbessern': {
    'deutsch': 'Kurzprofil mit Prompt verbessern',
    'englisch': 'Improve short profile with prompt',
    'französisch': 'Améliorer le profil court avec un prompt',
    'italienisch': 'Migliora il profilo breve con un prompt'
  },
  'Beschreiben Sie, welche Aspekte verbessert werden sollen...': {
    'deutsch': 'Beschreiben Sie, welche Aspekte verbessert werden sollen...',
    'englisch': 'Describe which aspects should be improved...',
    'französisch': 'Décrivez quels aspects doivent être améliorés...',
    'italienisch': 'Descrivi quali aspetti dovrebbero essere migliorati...'
  },
  'Beschreiben Sie, welche Aspekte dieser Berufserfahrung verbessert werden sollen...': {
    'deutsch': 'Beschreiben Sie, welche Aspekte dieser Berufserfahrung verbessert werden sollen...',
    'englisch': 'Describe which aspects of this work experience should be improved...',
    'französisch': 'Décrivez quels aspects de cette expérience professionnelle doivent être améliorés...',
    'italienisch': 'Descrivi quali aspetti di questa esperienza lavorativa dovrebbero essere migliorati...'
  },
  'Kernkompetenzen im CV-Template anzeigen': {
    'deutsch': 'Kernkompetenzen im CV-Template anzeigen',
    'englisch': 'Show Core Competencies in CV Template',
    'französisch': 'Afficher les compétences clés dans le modèle CV',
    'italienisch': 'Mostra competenze chiave nel template CV'
  },
  'Hier sind alle optimierten Kernkompetenzen aus Ihren CV-Daten:': {
    'deutsch': 'Hier sind alle optimierten Kernkompetenzen aus Ihren CV-Daten:',
    'englisch': 'Here are all optimized core competencies from your CV data:',
    'französisch': 'Voici toutes les compétences clés optimisées de vos données CV:',
    'italienisch': 'Ecco tutte le competenze chiave ottimizzate dai tuoi dati CV:'
  },
  'Hinzufügen': {
    'deutsch': 'Hinzufügen',
    'englisch': 'Add',
    'französisch': 'Ajouter',
    'italienisch': 'Aggiungi'
  },
  'Kernkompetenz': {
    'deutsch': 'Kernkompetenz',
    'englisch': 'Core Competency',
    'französisch': 'Compétence clé',
    'italienisch': 'Competenza chiave'
  },
  'Aktionen': {
    'deutsch': 'Aktionen',
    'englisch': 'Actions',
    'französisch': 'Actions',
    'italienisch': 'Azioni'
  },
  'Keine Kernkompetenzen verfügbar': {
    'deutsch': 'Keine Kernkompetenzen verfügbar',
    'englisch': 'No core competencies available',
    'französisch': 'Aucune compétence clé disponible',
    'italienisch': 'Nessuna competenza chiave disponibile'
  },
  'Ausbildungen im CV-Template anzeigen': {
    'deutsch': 'Ausbildungen im CV-Template anzeigen',
    'englisch': 'Show Education in CV Template',
    'französisch': 'Afficher la formation dans le modèle CV',
    'italienisch': 'Mostra formazione nel template CV'
  },
  'Hier sind alle optimierten Ausbildungen aus Ihren CV-Daten:': {
    'deutsch': 'Hier sind alle optimierten Ausbildungen aus Ihren CV-Daten:',
    'englisch': 'Here is all optimized education from your CV data:',
    'französisch': 'Voici toutes les formations optimisées de vos données CV:',
    'italienisch': 'Ecco tutta la formazione ottimizzata dai tuoi dati CV:'
  },
  'Von': {
    'deutsch': 'Von',
    'englisch': 'From',
    'französisch': 'De',
    'italienisch': 'Da'
  },
  'Bis': {
    'deutsch': 'Bis',
    'englisch': 'To',
    'französisch': 'À',
    'italienisch': 'A'
  },
  'Keine Ausbildungen verfügbar': {
    'deutsch': 'Keine Ausbildungen verfügbar',
    'englisch': 'No education available',
    'französisch': 'Aucune formation disponible',
    'italienisch': 'Nessuna formazione disponibile'
  },
  'Zertifizierungen im CV-Template anzeigen': {
    'deutsch': 'Zertifizierungen im CV-Template anzeigen',
    'englisch': 'Show Certifications in CV Template',
    'französisch': 'Afficher les certifications dans le modèle CV',
    'italienisch': 'Mostra certificazioni nel template CV'
  },
  'Hier sind alle optimierten Zertifizierungen aus Ihren CV-Daten:': {
    'deutsch': 'Hier sind alle optimierten Zertifizierungen aus Ihren CV-Daten:',
    'englisch': 'Here are all optimized certifications from your CV data:',
    'französisch': 'Voici toutes les certifications optimisées de vos données CV:',
    'italienisch': 'Ecco tutte le certificazioni ottimizzate dai tuoi dati CV:'
  },
  'Zertifizierung': {
    'deutsch': 'Zertifizierung',
    'englisch': 'Certification',
    'französisch': 'Certification',
    'italienisch': 'Certificazione'
  },
  'Keine Zertifizierungen verfügbar': {
    'deutsch': 'Keine Zertifizierungen verfügbar',
    'englisch': 'No certifications available',
    'französisch': 'Aucune certification disponible',
    'italienisch': 'Nessuna certificazione disponibile'
  },
  'IT-Skills im CV-Template anzeigen': {
    'deutsch': 'IT-Skills im CV-Template anzeigen',
    'englisch': 'Show IT Skills in CV Template',
    'französisch': 'Afficher les compétences IT dans le modèle CV',
    'italienisch': 'Mostra competenze IT nel template CV'
  },
  'Hier sind alle optimierten IT-Skills aus Ihren CV-Daten:': {
    'deutsch': 'Hier sind alle optimierten IT-Skills aus Ihren CV-Daten:',
    'englisch': 'Here are all optimized IT skills from your CV data:',
    'französisch': 'Voici toutes les compétences IT optimisées de vos données CV:',
    'italienisch': 'Ecco tutte le competenze IT ottimizzate dai tuoi dati CV:'
  },
  'IT-Skill': {
    'deutsch': 'IT-Skill',
    'englisch': 'IT Skill',
    'französisch': 'Compétence IT',
    'italienisch': 'Competenza IT'
  },
  'Keine IT-Skills verfügbar': {
    'deutsch': 'Keine IT-Skills verfügbar',
    'englisch': 'No IT skills available',
    'französisch': 'Aucune compétence IT disponible',
    'italienisch': 'Nessuna competenza IT disponibile'
  },
  'Branchen im CV-Template anzeigen': {
    'deutsch': 'Branchen im CV-Template anzeigen',
    'englisch': 'Show Industries in CV Template',
    'französisch': 'Afficher les secteurs dans le modèle CV',
    'italienisch': 'Mostra settori nel template CV'
  },
  'Hier sind alle optimierten Branchen aus Ihren CV-Daten:': {
    'deutsch': 'Hier sind alle optimierten Branchen aus Ihren CV-Daten:',
    'englisch': 'Here are all optimized industries from your CV data:',
    'französisch': 'Voici tous les secteurs optimisés de vos données CV:',
    'italienisch': 'Ecco tutti i settori ottimizzati dai tuoi dati CV:'
  },
  'Keine Branchen verfügbar': {
    'deutsch': 'Keine Branchen verfügbar',
    'englisch': 'No industries available',
    'französisch': 'Aucun secteur disponible',
    'italienisch': 'Nessun settore disponibile'
  },
  'Sprachen im CV-Template anzeigen': {
    'deutsch': 'Sprachen im CV-Template anzeigen',
    'englisch': 'Show Languages in CV Template',
    'französisch': 'Afficher les langues dans le modèle CV',
    'italienisch': 'Mostra lingue nel template CV'
  },
  'Hier sind alle optimierten Sprachen aus Ihren CV-Daten:': {
    'deutsch': 'Hier sind alle optimierten Sprachen aus Ihren CV-Daten:',
    'englisch': 'Here are all optimized languages from your CV data:',
    'französisch': 'Voici toutes les langues optimisées de vos données CV:',
    'italienisch': 'Ecco tutte le lingue ottimizzate dai tuoi dati CV:'
  },
  'Keine Sprachen verfügbar': {
    'deutsch': 'Keine Sprachen verfügbar',
    'englisch': 'No languages available',
    'französisch': 'Aucune langue disponible',
    'italienisch': 'Nessuna lingua disponibile'
  },
  'Hobbies im CV-Template anzeigen': {
    'deutsch': 'Hobbies im CV-Template anzeigen',
    'englisch': 'Show Hobbies in CV Template',
    'französisch': 'Afficher les loisirs dans le modèle CV',
    'italienisch': 'Mostra hobby nel template CV'
  },
  'Hier sind alle optimierten Hobbies aus Ihren CV-Daten:': {
    'deutsch': 'Hier sind alle optimierten Hobbies aus Ihren CV-Daten:',
    'englisch': 'Here are all optimized hobbies from your CV data:',
    'französisch': 'Voici tous les loisirs optimisés de vos données CV:',
    'italienisch': 'Ecco tutti gli hobby ottimizzati dai tuoi dati CV:'
  },
  'Keine Hobbies verfügbar': {
    'deutsch': 'Keine Hobbies verfügbar',
    'englisch': 'No hobbies available',
    'französisch': 'Aucun loisir disponible',
    'italienisch': 'Nessun hobby disponibile'
  },
  'Weitere Angaben im CV-Template anzeigen': {
    'deutsch': 'Weitere Angaben im CV-Template anzeigen',
    'englisch': 'Show Additional Information in CV Template',
    'französisch': 'Afficher les informations supplémentaires dans le modèle CV',
    'italienisch': 'Mostra informazioni aggiuntive nel template CV'
  },
  'Hier sind alle optimierten Weitere Angaben aus Ihren CV-Daten:': {
    'deutsch': 'Hier sind alle optimierten Weitere Angaben aus Ihren CV-Daten:',
    'englisch': 'Here is all optimized additional information from your CV data:',
    'französisch': 'Voici toutes les informations supplémentaires optimisées de vos données CV:',
    'italienisch': 'Ecco tutte le informazioni aggiuntive ottimizzate dai tuoi dati CV:'
  },
  'Info': {
    'deutsch': 'Info',
    'englisch': 'Info',
    'französisch': 'Info',
    'italienisch': 'Info'
  },
  'Keine Weitere Angaben verfügbar': {
    'deutsch': 'Keine Weitere Angaben verfügbar',
    'englisch': 'No additional information available',
    'französisch': 'Aucune information supplémentaire disponible',
    'italienisch': 'Nessuna informazione aggiuntiva disponibile'
  },
  'Berufserfahrungen im CV-Template anzeigen': {
    'deutsch': 'Berufserfahrungen im CV-Template anzeigen',
    'englisch': 'Show Work Experience in CV Template',
    'französisch': 'Afficher l\'expérience professionnelle dans le modèle CV',
    'italienisch': 'Mostra esperienza lavorativa nel template CV'
  },
  'Weitere Berufserfahrungen im CV-Template anzeigen': {
    'deutsch': 'Weitere Berufserfahrungen im CV-Template anzeigen',
    'englisch': 'Show Additional Work Experience in CV Template',
    'französisch': 'Afficher l\'expérience professionnelle supplémentaire dans le modèle CV',
    'italienisch': 'Mostra esperienza lavorativa aggiuntiva nel template CV'
  },
  'Bearbeiten Sie diese Berufserfahrung:': {
    'deutsch': 'Bearbeiten Sie diese Berufserfahrung:',
    'englisch': 'Edit this work experience:',
    'französisch': 'Modifiez cette expérience professionnelle:',
    'italienisch': 'Modifica questa esperienza lavorativa:'
  },
  'Hier sind alle optimierten Berufserfahrungen aus Ihren CV-Daten:': {
    'deutsch': 'Hier sind alle optimierten Berufserfahrungen aus Ihren CV-Daten:',
    'englisch': 'Here is all optimized work experience from your CV data:',
    'französisch': 'Voici toutes les expériences professionnelles optimisées de vos données CV:',
    'italienisch': 'Ecco tutta l\'esperienza lavorativa ottimizzata dai tuoi dati CV:'
  },
  'Unternehmen': {
    'deutsch': 'Unternehmen',
    'englisch': 'Company',
    'französisch': 'Entreprise',
    'italienisch': 'Azienda'
  },
  'Relevant': {
    'deutsch': 'Relevant',
    'englisch': 'Relevant',
    'französisch': 'Pertinent',
    'italienisch': 'Rilevante'
  },
  'Nicht relevant': {
    'deutsch': 'Nicht relevant',
    'englisch': 'Not relevant',
    'französisch': 'Non pertinent',
    'italienisch': 'Non rilevante'
  },
  'Mit Relevanz kannst du angeben, ob eine Berufserfahrung mit Beschreibung unter BERUFLICHER WERDEGANG oder mit minimalen Informationen unter WEITERE BERUFSERFAHRUNGEN aufgeführt werden soll.': {
    'deutsch': 'Mit Relevanz kannst du angeben, ob eine Berufserfahrung mit Beschreibung unter BERUFLICHER WERDEGANG oder mit minimalen Informationen unter WEITERE BERUFSERFAHRUNGEN aufgeführt werden soll.',
    'englisch': 'With relevance you can specify whether a work experience should be listed with description under PROFESSIONAL EXPERIENCE or with minimal information under ADDITIONAL WORK EXPERIENCE.',
    'französisch': 'Avec la pertinence, vous pouvez spécifier si une expérience professionnelle doit être répertoriée avec description sous PARCOURS PROFESSIONNEL ou avec des informations minimales sous AUTRES EXPÉRIENCES PROFESSIONNELLES.',
    'italienisch': 'Con la rilevanza puoi specificare se un\'esperienza lavorativa deve essere elencata con descrizione sotto ESPERIENZA PROFESSIONALE o con informazioni minime sotto ALTRE ESPERIENZE PROFESSIONALI.'
  },
  'Speichern': {
    'deutsch': 'Speichern',
    'englisch': 'Save',
    'französisch': 'Enregistrer',
    'italienisch': 'Salva'
  },
  'Zurück': {
    'deutsch': 'Zurück',
    'englisch': 'Back',
    'französisch': 'Retour',
    'italienisch': 'Indietro'
  },
  'Löschen': {
    'deutsch': 'Löschen',
    'englisch': 'Delete',
    'französisch': 'Supprimer',
    'italienisch': 'Elimina'
  },
  'Keine Berufserfahrungen verfügbar': {
    'deutsch': 'Keine Berufserfahrungen verfügbar',
    'englisch': 'No work experience available',
    'französisch': 'Aucune expérience professionnelle disponible',
    'italienisch': 'Nessuna esperienza lavorativa disponibile'
  },
  'Motivationsschreiben erstellen': {
    'deutsch': 'Motivationsschreiben erstellen',
    'englisch': 'Create Cover Letter',
    'französisch': 'Créer une lettre de motivation',
    'italienisch': 'Crea lettera di motivazione'
  },
  'Motivationsschreiben anzeigen': {
    'deutsch': 'Motivationsschreiben anzeigen',
    'englisch': 'Show Cover Letter',
    'französisch': 'Afficher la lettre de motivation',
    'italienisch': 'Mostra lettera di motivazione'
  },
  'Bitte lies das Motivationsschreiben gut durch. Willst du etwas ändern, klicke auf den entsprechenden Text. Willst du es herunter laden, klicke auf das Download Icon oben rechts.': {
    'deutsch': 'Bitte lies das Motivationsschreiben gut durch. Willst du etwas ändern, klicke auf den entsprechenden Text. Willst du es herunter laden, klicke auf das Download Icon oben rechts.',
    'englisch': 'Please read the cover letter carefully. If you want to change something, click on the corresponding text. If you want to download it, click on the download icon at the top right.',
    'französisch': 'Veuillez lire attentivement la lettre de motivation. Si vous souhaitez modifier quelque chose, cliquez sur le texte correspondant. Si vous souhaitez la télécharger, cliquez sur l\'icône de téléchargement en haut à droite.',
    'italienisch': 'Si prega di leggere attentamente la lettera di motivazione. Se vuoi modificare qualcosa, fai clic sul testo corrispondente. Se vuoi scaricarla, fai clic sull\'icona di download in alto a destra.'
  },
  'Hier kannst du unter Angaben deiner Motivation für die Bewerbung ein Motivationsschreiben erstellen. Das Motivationsschreiben wird basierend auf deinen CV-Daten und passend zur Stellenbeschreibung erstellt.': {
    'deutsch': 'Hier kannst du unter Angaben deiner Motivation für die Bewerbung ein Motivationsschreiben erstellen. Das Motivationsschreiben wird basierend auf deinen CV-Daten und passend zur Stellenbeschreibung erstellt.',
    'englisch': 'Here you can create a cover letter by providing your motivation for the application. The cover letter will be created based on your CV data and tailored to the job description.',
    'französisch': 'Ici, vous pouvez créer une lettre de motivation en indiquant votre motivation pour la candidature. La lettre de motivation sera créée sur la base de vos données CV et adaptée à la description du poste.',
    'italienisch': 'Qui puoi creare una lettera di motivazione indicando la tua motivazione per la candidatura. La lettera di motivazione sarà creata sulla base dei tuoi dati CV e adattata alla descrizione del lavoro.'
  },
  'Hier kannst du dir deinen CV in 3 verschiedenen Designs anzeigen lassen. Wähle ein Design aus und lies die Texte sorgfältig durch. Wenn du etwas ändern willst, klicke auf das entsprechende Element. Willst du ein Design ändern, klick auf das Zahnrad Icon oben rechts. Willst du den CV herunterladen, klicke auf das Download Icon oben rechts.': {
    'deutsch': 'Hier kannst du dir deinen CV in 3 verschiedenen Designs anzeigen lassen. Wähle ein Design aus und lies die Texte sorgfältig durch. Wenn du etwas ändern willst, klicke auf das entsprechende Element. Willst du ein Design ändern, klick auf das Zahnrad Icon oben rechts. Willst du den CV herunterladen, klicke auf das Download Icon oben rechts.',
    'englisch': 'Here you can view your CV in 3 different designs. Select a design and read the texts carefully. If you want to change something, click on the corresponding element. If you want to change a design, click on the gear icon at the top right. If you want to download the CV, click on the download icon at the top right.',
    'französisch': 'Ici, vous pouvez afficher votre CV dans 3 designs différents. Sélectionnez un design et lisez attentivement les textes. Si vous souhaitez modifier quelque chose, cliquez sur l\'élément correspondant. Si vous souhaitez modifier un design, cliquez sur l\'icône d\'engrenage en haut à droite. Si vous souhaitez télécharger le CV, cliquez sur l\'icône de téléchargement en haut à droite.',
    'italienisch': 'Qui puoi visualizzare il tuo CV in 3 design diversi. Seleziona un design e leggi attentamente i testi. Se vuoi modificare qualcosa, fai clic sull\'elemento corrispondente. Se vuoi modificare un design, fai clic sull\'icona dell\'ingranaggio in alto a destra. Se vuoi scaricare il CV, fai clic sull\'icona di download in alto a destra.'
  },
  'Beschreibung wird extrahiert': {
    'deutsch': 'Beschreibung wird extrahiert',
    'englisch': 'Description being extracted',
    'französisch': 'Description en cours d\'extraction',
    'italienisch': 'Descrizione in estrazione'
  },
  'QR-Code wird geladen...': {
    'deutsch': 'QR-Code wird geladen...',
    'englisch': 'QR code loading...',
    'französisch': 'Chargement du code QR...',
    'italienisch': 'Caricamento del codice QR...'
  },
  'Der QR-Code ist 10 Minuten gültig. Das Foto wird automatisch als Profilbild übernommen.': {
    'deutsch': 'Der QR-Code ist 10 Minuten gültig. Das Foto wird automatisch als Profilbild übernommen.',
    'englisch': 'The QR code is valid for 10 minutes. The photo will be automatically used as profile picture.',
    'französisch': 'Le code QR est valable 10 minutes. La photo sera automatiquement utilisée comme photo de profil.',
    'italienisch': 'Il codice QR è valido per 10 minuti. La foto verrà automaticamente utilizzata come foto profilo.'
  },
  'CV Daten werden importiert...': {
    'deutsch': 'CV Daten werden importiert...',
    'englisch': 'CV data being imported...',
    'französisch': 'Importation des données CV...',
    'italienisch': 'Importazione dati CV...'
  },
  'CV wird verarbeitet...': {
    'deutsch': 'CV wird verarbeitet...',
    'englisch': 'CV being processed...',
    'französisch': 'CV en cours de traitement...',
    'italienisch': 'CV in elaborazione...'
  },
  'Kurzprofil': {
    'deutsch': 'Kurzprofil',
    'englisch': 'Short Profile',
    'französisch': 'Profil court',
    'italienisch': 'Profilo breve'
  },
  'Kernkompetenzen': {
    'deutsch': 'Kernkompetenzen',
    'englisch': 'Core Competencies',
    'französisch': 'Compétences clés',
    'italienisch': 'Competenze chiave'
  },
  'Relevante Kernkompetenzen': {
    'deutsch': 'Relevante Kernkompetenzen',
    'englisch': 'Relevant Core Competencies',
    'französisch': 'Compétences clés pertinentes',
    'italienisch': 'Competenze chiave rilevanti'
  },
  'Kernkompetenz aus gespeicherten Daten hinzufügen': {
    'deutsch': 'Kernkompetenz aus gespeicherten Daten hinzufügen',
    'englisch': 'Add Core Competency from Saved Data',
    'französisch': 'Ajouter une compétence clé à partir des données enregistrées',
    'italienisch': 'Aggiungi competenza chiave dai dati salvati'
  },
  'Beschreibung': {
    'deutsch': 'Beschreibung',
    'englisch': 'Description',
    'französisch': 'Description',
    'italienisch': 'Descrizione'
  },
  'Branche': {
    'deutsch': 'Branche',
    'englisch': 'Industry',
    'französisch': 'Secteur',
    'italienisch': 'Settore'
  },
  'Jahre': {
    'deutsch': 'Jahre',
    'englisch': 'Years',
    'französisch': 'Années',
    'italienisch': 'Anni'
  },
  'Branchenerfahrung': {
    'deutsch': 'Branchenerfahrung',
    'englisch': 'Industry Experience',
    'französisch': 'Expérience sectorielle',
    'italienisch': 'Esperienza settoriale'
  },
  'Firma': {
    'deutsch': 'Firma',
    'englisch': 'Company',
    'französisch': 'Entreprise',
    'italienisch': 'Azienda'
  },
  'Position': {
    'deutsch': 'Position',
    'englisch': 'Position',
    'französisch': 'Poste',
    'italienisch': 'Posizione'
  },
  'Start': {
    'deutsch': 'Start',
    'englisch': 'Start',
    'französisch': 'Début',
    'italienisch': 'Inizio'
  },
  'Ende': {
    'deutsch': 'Ende',
    'englisch': 'End',
    'französisch': 'Fin',
    'italienisch': 'Fine'
  },
  'Ausbildung': {
    'deutsch': 'Ausbildung',
    'englisch': 'Education',
    'französisch': 'Formation',
    'italienisch': 'Formazione'
  },
  'Institution': {
    'deutsch': 'Institution',
    'englisch': 'Institution',
    'französisch': 'Institution',
    'italienisch': 'Istituzione'
  },
  'Abschluss': {
    'deutsch': 'Abschluss',
    'englisch': 'Degree',
    'französisch': 'Diplôme',
    'italienisch': 'Diploma'
  },
  'Zertifikate': {
    'deutsch': 'Zertifikate',
    'englisch': 'Certificates',
    'französisch': 'Certificats',
    'italienisch': 'Certificati'
  },
  'Zertifikat': {
    'deutsch': 'Zertifikat',
    'englisch': 'Certificate',
    'französisch': 'Certificat',
    'italienisch': 'Certificato'
  },
  'Jahr': {
    'deutsch': 'Jahr',
    'englisch': 'Year',
    'französisch': 'Année',
    'italienisch': 'Anno'
  },
  'Datum': {
    'deutsch': 'Datum',
    'englisch': 'Date',
    'französisch': 'Date',
    'italienisch': 'Data'
  },
  'Name': {
    'deutsch': 'Name',
    'englisch': 'Name',
    'französisch': 'Nom',
    'italienisch': 'Nome'
  },
  'Aussteller': {
    'deutsch': 'Aussteller',
    'englisch': 'Issuer',
    'französisch': 'Émetteur',
    'italienisch': 'Emittente'
  },
  'Sprachkenntnisse': {
    'deutsch': 'Sprachkenntnisse',
    'englisch': 'Language Skills',
    'französisch': 'Compétences linguistiques',
    'italienisch': 'Competenze linguistiche'
  },
  'Sprache': {
    'deutsch': 'Sprache',
    'englisch': 'Language',
    'französisch': 'Langue',
    'italienisch': 'Lingua'
  },
  'Niveau': {
    'deutsch': 'Niveau',
    'englisch': 'Level',
    'französisch': 'Niveau',
    'italienisch': 'Livello'
  },
  'IT-Kenntnisse': {
    'deutsch': 'IT-Kenntnisse',
    'englisch': 'IT Skills',
    'französisch': 'Compétences IT',
    'italienisch': 'Competenze IT'
  },
  'Skill': {
    'deutsch': 'Skill',
    'englisch': 'Skill',
    'französisch': 'Compétence',
    'italienisch': 'Competenza'
  },
  'Weitere Angaben': {
    'deutsch': 'Weitere Angaben',
    'englisch': 'Additional Information',
    'französisch': 'Informations supplémentaires',
    'italienisch': 'Informazioni aggiuntive'
  },
  'Angabe': {
    'deutsch': 'Angabe',
    'englisch': 'Information',
    'französisch': 'Information',
    'italienisch': 'Informazione'
  },
  'Details': {
    'deutsch': 'Details',
    'englisch': 'Details',
    'französisch': 'Détails',
    'italienisch': 'Dettagli'
  },
  'Hobbys': {
    'deutsch': 'Hobbys',
    'englisch': 'Hobbies',
    'französisch': 'Loisirs',
    'italienisch': 'Hobby'
  },
  'Hobby': {
    'deutsch': 'Hobby',
    'englisch': 'Hobby',
    'französisch': 'Loisir',
    'italienisch': 'Hobby'
  },
  'Daten manuell befüllen': {
    'deutsch': 'Daten manuell befüllen',
    'englisch': 'Fill in data manually',
    'französisch': 'Remplir les données manuellement',
    'italienisch': 'Compila i dati manualmente'
  },
  'CV': {
    'deutsch': 'CV',
    'englisch': 'CV',
    'französisch': 'CV',
    'italienisch': 'CV'
  },
  'PDF verfügbar zum Download': {
    'deutsch': 'PDF verfügbar zum Download',
    'englisch': 'PDF available for download',
    'französisch': 'PDF disponible au téléchargement',
    'italienisch': 'PDF disponibile per il download'
  },
  'Download': {
    'deutsch': 'Download',
    'englisch': 'Download',
    'französisch': 'Télécharger',
    'italienisch': 'Scarica'
  },
  'Firmenname eingeben...': {
    'deutsch': 'Firmenname eingeben...',
    'englisch': 'Enter company name...',
    'französisch': 'Entrez le nom de l\'entreprise...',
    'italienisch': 'Inserisci nome azienda...'
  },
  'Branche eingeben...': {
    'deutsch': 'Branche eingeben...',
    'englisch': 'Enter industry...',
    'französisch': 'Entrez le secteur...',
    'italienisch': 'Inserisci settore...'
  },
  'Rollentitel eingeben...': {
    'deutsch': 'Rollentitel eingeben...',
    'englisch': 'Enter role title...',
    'französisch': 'Entrez le titre du poste...',
    'italienisch': 'Inserisci titolo ruolo...'
  },
  'Notizen zur Bewerbung hinzufügen...': {
    'deutsch': 'Notizen zur Bewerbung hinzufügen...',
    'englisch': 'Add notes to application...',
    'französisch': 'Ajouter des notes à la candidature...',
    'italienisch': 'Aggiungi note alla candidatura...'
  },
  'Stellenbeschreibung': {
    'deutsch': 'Stellenbeschreibung',
    'englisch': 'Job Description',
    'französisch': 'Description du poste',
    'italienisch': 'Descrizione del lavoro'
  },
  'Aufgaben': {
    'deutsch': 'Aufgaben',
    'englisch': 'Tasks',
    'französisch': 'Tâches',
    'italienisch': 'Compiti'
  },
  'Anforderungen': {
    'deutsch': 'Anforderungen',
    'englisch': 'Requirements',
    'französisch': 'Exigences',
    'italienisch': 'Requisiti'
  },
  'Keine Informationen verfügbar': {
    'deutsch': 'Keine Informationen verfügbar',
    'englisch': 'No information available',
    'französisch': 'Aucune information disponible',
    'italienisch': 'Nessuna informazione disponibile'
  },
  'Header Farbe': {
    'deutsch': 'Header Farbe',
    'englisch': 'Header Color',
    'französisch': 'Couleur de l\'en-tête',
    'italienisch': 'Colore intestazione'
  },
  'Spaltenfarbe': {
    'deutsch': 'Spaltenfarbe',
    'englisch': 'Column Color',
    'französisch': 'Couleur de la colonne',
    'italienisch': 'Colore colonna'
  },
  'Farbe:': {
    'deutsch': 'Farbe:',
    'englisch': 'Color:',
    'französisch': 'Couleur:',
    'italienisch': 'Colore:'
  },
  'Transparenz (0-100%):': {
    'deutsch': 'Transparenz (0-100%):',
    'englisch': 'Transparency (0-100%):',
    'französisch': 'Transparence (0-100%):',
    'italienisch': 'Trasparenza (0-100%):'
  },
  'Übernehmen': {
    'deutsch': 'Übernehmen',
    'englisch': 'Apply',
    'französisch': 'Appliquer',
    'italienisch': 'Applica'
  },
  'Offen': {
    'deutsch': 'Offen',
    'englisch': 'Open',
    'französisch': 'Ouvert',
    'italienisch': 'Aperto'
  },
  'Vorstellungsgespräch': {
    'deutsch': 'Vorstellungsgespräch',
    'englisch': 'Interview',
    'französisch': 'Entretien',
    'italienisch': 'Colloquio'
  },
  'In Prüfung': {
    'deutsch': 'In Prüfung',
    'englisch': 'Under Review',
    'französisch': 'En examen',
    'italienisch': 'In revisione'
  },
  'Freigegeben': {
    'deutsch': 'Freigegeben',
    'englisch': 'Approved',
    'französisch': 'Approuvé',
    'italienisch': 'Approvato'
  },
  'Zusage': {
    'deutsch': 'Zusage',
    'englisch': 'Accepted',
    'französisch': 'Accepté',
    'italienisch': 'Accettato'
  },
  'Absage': {
    'deutsch': 'Absage',
    'englisch': 'Rejected',
    'französisch': 'Refusé',
    'italienisch': 'Rifiutato'
  },
  'Geschlossen': {
    'deutsch': 'Geschlossen',
    'englisch': 'Closed',
    'französisch': 'Fermé',
    'italienisch': 'Chiuso'
  },
  'Bullet Points': {
    'deutsch': 'Bullet Points',
    'englisch': 'Bullet Points',
    'französisch': 'Puces',
    'italienisch': 'Elenco puntato'
  },
  'Nach Relevanz sortieren': {
    'deutsch': 'Nach Relevanz sortieren',
    'englisch': 'Sort by relevance',
    'französisch': 'Trier par pertinence',
    'italienisch': 'Ordina per rilevanza'
  },
  'Tonalität': {
    'deutsch': 'Tonalität',
    'englisch': 'Tonality',
    'französisch': 'Tonalité',
    'italienisch': 'Tonalità'
  },
  'Text Einstellungen': {
    'deutsch': 'Text Einstellungen',
    'englisch': 'Text Settings',
    'französisch': 'Paramètres du texte',
    'italienisch': 'Impostazioni testo'
  },
  'Textlänge': {
    'deutsch': 'Textlänge',
    'englisch': 'Text Length',
    'französisch': 'Longueur du texte',
    'italienisch': 'Lunghezza del testo'
  },
  'Locker': {
    'deutsch': 'Locker',
    'englisch': 'Casual',
    'französisch': 'Décontracté',
    'italienisch': 'Informale'
  },
  'Formell': {
    'deutsch': 'Formell',
    'englisch': 'Formal',
    'französisch': 'Formel',
    'italienisch': 'Formale'
  },
  'Bescheiden': {
    'deutsch': 'Bescheiden',
    'englisch': 'Modest',
    'französisch': 'Modeste',
    'italienisch': 'Modesto'
  },
  'Selbstbewusst': {
    'deutsch': 'Selbstbewusst',
    'englisch': 'Confident',
    'französisch': 'Confiant',
    'italienisch': 'Sicuro di sé'
  },
  'Aktiv': {
    'deutsch': 'Aktiv',
    'englisch': 'Active',
    'französisch': 'Actif',
    'italienisch': 'Attivo'
  },
  'Sachlich': {
    'deutsch': 'Sachlich',
    'englisch': 'Factual',
    'französisch': 'Factuel',
    'italienisch': 'Oggettivo'
  },
  'Kreativ': {
    'deutsch': 'Kreativ',
    'englisch': 'Creative',
    'französisch': 'Créatif',
    'italienisch': 'Creativo'
  }
};

// Helper function to get translated CV label based on current UI language
export const getTranslatedCvLabel = (label: string, currentLanguage: string, country?: string | null): string => {
  const languageMap: { [key: string]: string } = {
    'de': 'deutsch',
    'fr': 'französisch',
    'it': 'italienisch',
    'en': 'englisch'
  };
  const uiLanguage = languageMap[currentLanguage] || 'deutsch';
  const translated = cvLabelTranslations[label]?.[uiLanguage as Language] || label;
  // Ersetze ß durch ss für Schweizer Benutzer
  if (country === 'CH') {
    return translated.replace(/ß/g, 'ss');
  }
  return translated;
};
